module.exports = __webpack_public_path__ + "img/Heating - 3 Units.03d342dd.jpg";